import { useCallback, useEffect, useState } from 'react'

import { ArrowUpward } from '@mui/icons-material'

import { ButtonWrapper } from './index.styles'

const SCROLL_VALUE = 300

const ScrollToTopButton = ({ behavior }: { behavior?: 'smooth' | 'auto' }) => {
  const [visible, setVisible] = useState(false)

  const toggleVisible = useCallback(() => {
    const scrolled = document.documentElement.scrollTop
    if (!visible && scrolled > SCROLL_VALUE) {
      setVisible(true)
    } else if (visible && scrolled <= SCROLL_VALUE) {
      setVisible(false)
    }
  }, [visible])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: behavior ?? 'smooth',
    })
    setVisible(false)
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible)

    return () => {
      window.removeEventListener('scroll', toggleVisible)
    }
  }, [toggleVisible])

  if (!visible) {
    return null
  }

  return (
    <ButtonWrapper>
      <ArrowUpward onClick={scrollToTop} />
    </ButtonWrapper>
  )
}

export default ScrollToTopButton
